import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredLoadFileCreateAtom = createMutationAtomFactory(
  'brokerage.brokeredLoadFileCreate',
  (params: {
    loadId: string;
    fileName: string;
    fileSize: number;
    mimeType: string;
    notes?: string;
    public?: boolean;
  }) => ({
    tradeLoadPhotoCreate: {
      __args: {
        loadId: params.loadId,
        input: {
          fileName: params.fileName,
          fileSize: params.fileSize,
          mimeType: params.mimeType,
          notes: params.notes,
          public: params.public ?? false,
        },
      },
      file: {
        id: true,
        fileName: true,
        fileSize: true,
        mimeType: true,
        status: true,
      },
      uploadUrl: true,
    },
  }),
  { showLoadingOverlay: false },
);
